import { useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, imgSrc } from "../../lib/api";

export const ImageField = ({ value, onChange, testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (file) => {
    setBusy(true);
    try {
      const { path } = await api.adminUpload(file);
      onChange(path);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex items-center gap-4">
      <div className="w-20 h-20 rounded-lg overflow-hidden card-surface shrink-0">
        {value && <img src={imgSrc(value)} alt="" className="w-full h-full object-cover" />}
      </div>
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" data-testid={`${testid}-file`}
        onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) pick(f); }} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`${testid}-upload-button`}
        className="btn-line rounded-full px-4 py-2 text-sm inline-flex items-center gap-2">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Upload
      </button>
    </div>
  );
};
